import { useTranslation } from 'react-i18next';
import { MovementsList as UniversalMovementsList } from '@/common/components/MovementsList/MovementsList';
import { Section } from '@/common/components/Section/Section';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { IMovement } from '@/common/integrations/menhir/employee/movements/movements.types';
import { GroupedTransactionList } from '@/web/components/GroupedTransactionList/GroupedTransactionList';
import { TransactionList } from '@/web/components/TransactionList/TransactionList';
import { MovementsDetail } from '@/web/components/TransactionList/components/MovementsDetail/MovementsDetail';

export const MovementsList = ({
  movements,
  isGrouped,
  hideTitle,
  translationPrefix,
  loading,
}: IMovementsListProps) => {
  const { t } = useTranslation();
  const {
    features: { ff_sea_activity },
  } = useFeatures();

  if (ff_sea_activity) {
    const showTitle = isGrouped && !hideTitle;
    return (
      <Section title={showTitle ? t('wallet.activity.title') : undefined}>
        <UniversalMovementsList
          movements={movements}
          grouped={isGrouped}
          loading={loading}
        />
      </Section>
    );
  }

  const MovementsListView = isGrouped
    ? GroupedTransactionList
    : TransactionList;

  return (
    <>
      <MovementsListView
        type="movements"
        transactions={movements}
        hideTitle={hideTitle}
        translationPrefix={translationPrefix}
      />
      <MovementsDetail />
    </>
  );
};

interface IMovementsListProps {
  movements: IMovement[];
  isGrouped?: boolean;
  hideTitle?: boolean;
  translationPrefix?: 'home';
  loading?: boolean;
}
